import { useSettings } from "@/context/SettingsContext";
import { buildWhatsappUrl, track } from "@/lib/api";
import { MessageCircle, Phone } from "lucide-react";

export default function FloatingWhatsapp({ message }) {
  const { settings } = useSettings();
  const wa = settings?.whatsapp_number || "+919866933180";
  const phone = settings?.phone_primary || settings?.whatsapp_number || "+919866933180";
  const url = buildWhatsappUrl(wa, message || "Hello! I'd like to know more about your travel packages.");

  // Sit above the mobile bottom nav on small screens (bottom nav ≈ 72px + safe area).
  return (
    <div
      className="fixed right-4 sm:right-6 z-40 flex flex-col items-center gap-3 bottom-[calc(90px+env(safe-area-inset-bottom))] lg:bottom-6"
      data-testid="floating-stack"
    >
      {phone && (
        <a
          href={`tel:${phone}`}
          onClick={() => track("call_click", "floating")}
          data-testid="floating-call-btn"
          aria-label="Call us"
          className="relative w-13 h-13 sm:w-14 sm:h-14 rounded-full bg-brand-navy-800 text-white shadow-2xl grid place-items-center hover:scale-105 transition-transform"
          style={{ width: 52, height: 52 }}
        >
          <Phone className="w-5 h-5" />
          <span className="absolute inset-0 rounded-full bg-brand-navy-800/40 animate-ping" />
        </a>
      )}
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={() => track("whatsapp_click", "floating")}
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="relative rounded-full bg-[#25D366] text-white shadow-2xl grid place-items-center hover:scale-105 transition-transform"
        style={{ width: 52, height: 52 }}
      >
        <MessageCircle className="w-5 h-5" />
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
      </a>
    </div>
  );
}
